import {connect} from "react-redux";
import * as customerSelector from "../../../../../state/detail/selector";
import * as taskWidgetSelector from "../../../../../state/task-widget/selector";
import * as action from "../../../../../state/image/action";
import * as taskWidgetAction from "../../../../../state/task-widget/action";
import PreCheckinPhoto from "./PreCheckinPhoto";

const mapStateToProps = (state, props) => {
    return {
        customerId: customerSelector.selectCustomerId(state),
        selectedImageVersions: taskWidgetSelector.selectSelectedImageVersions(state),
    }
}

const mapDispatchToProps = {
    uploadCustomerImage: action.uploadCustomerImage,
    rotateCustomerImage: action.rotateCustomerImage,
    setImageTypeMetaData: action.setImageTypeMetaData,
    setSelectedImageVersions: taskWidgetAction.setSelectedImageVersions,
}

export default connect(mapStateToProps, mapDispatchToProps)(PreCheckinPhoto)



// WEBPACK FOOTER //
// ./src/modules/customer/component/task-widget/customerPreCheckinImageWidget/components/PreCheckinPhoto/PreCheckinPhotoContainer.js